import { z } from 'zod';

export const getDocumentSeriesTypesBaseSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    documentTypeID: z.string(),
    documentSeriesID: z.string(),
    defaultWarehouseID: z.string().optional(),
    isDefault: z.number(),
  })
);

export type GetAllDocumentSeriesTypesResponse = z.infer<typeof getDocumentSeriesTypesBaseSchema>;
